<app-page-header header="policyholder.title" />

<qbe-panel-component>
  <app-form-element
    [header]="'policyholder.isCompany.' + (isAppTravelAgency ? 'travelAgency.' : '') + 'label'"
    [tooltip]="'policyholder.isCompany.' + (isAppTravelAgency ? 'travelAgency.' : '') + 'tooltip'"
  >
    <app-dynamic-input [formGroup]="formGroup" name="isCompany" inputType="yesNo" label="policyholder.isCompany.label"></app-dynamic-input>
  </app-form-element>
  <app-form-element [header]="'policyholder.yourDetails.' + (isAppTravelAgency ? 'travel-agency-title' : 'title')">
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'policyholder.yourDetails.description' | translate }}
      </p>
    </ng-container>
    <ng-template [ngIf]="!this.formGroup.controls.isCompany.value">
      <app-dynamic-input
        [formGroup]="formGroup"
        name="firstName"
        inputType="text"
        label="policyholder.firstName.label"
        placeholder="policyholder.firstName.placeholder"
        maxLength="32"
        autocompleteType="given-name"
      ></app-dynamic-input>
      <app-dynamic-input
        [formGroup]="formGroup"
        name="lastName"
        inputType="text"
        label="policyholder.lastName.label"
        placeholder="policyholder.lastName.placeholder"
        maxLength="50"
        autocompleteType="family-name"
      ></app-dynamic-input>
      <app-dynamic-input
        *ngIf="!this.formGroup.controls.isForeigner.value"
        [formGroup]="formGroup"
        name="pesel"
        inputType="pesel"
        label="policyholder.pesel.label"
        placeholder="policyholder.pesel.placeholder"
      ></app-dynamic-input>
      <app-dynamic-input
        [formGroup]="formGroup"
        name="isForeigner"
        inputType="checkbox"
        label="policyholder.isForeigner.label"
      ></app-dynamic-input>
      <app-dynamic-input
        *ngIf="this.formGroup.controls.isForeigner.value"
        [formGroup]="formGroup"
        name="passport"
        inputType="text"
        label="policyholder.passport.label"
        placeholder="policyholder.passport.placeholder"
      ></app-dynamic-input>
    </ng-template>
    <ng-template [ngIf]="this.formGroup.controls.isCompany.value">
      <app-dynamic-input
        [formGroup]="formGroup"
        name="companyName"
        inputType="text"
        label="policyholder.companyName.label"
        placeholder="policyholder.companyName.placeholder"
      ></app-dynamic-input>
      <app-dynamic-input
        [formGroup]="formGroup"
        name="nip"
        inputType="text"
        label="policyholder.nip.label"
        placeholder="policyholder.nip.placeholder"
        mask="0000000000"
      ></app-dynamic-input>
      <app-dynamic-input
        [formGroup]="formGroup"
        name="regon"
        inputType="text"
        label="policyholder.regon.label"
        placeholder="policyholder.regon.placeholder"
        maxLength="14"
      ></app-dynamic-input>
    </ng-template>
    <div [ngClass]="{ phoneNumber: !this.formGroup.controls.isCompany.value }">
      <app-dynamic-input
        [formGroup]="formGroup"
        name="phoneNumber"
        inputType="phoneNumber"
        label="policyholder.phoneNumber.label"
        placeholder="policyholder.phoneNumber.placeholder"
      ></app-dynamic-input>
    </div>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="emailAddress"
      inputType="email"
      label="policyholder.emailAddress.label"
      placeholder="policyholder.emailAddress.placeholder"
    ></app-dynamic-input>
    <p nxCopytext="normal" class="address">
      {{ 'policyholder.address.title' | translate }}
    </p>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="postCode"
      inputType="postCode"
      autocompleteType="postal-code"
      label="policyholder.postCode.label"
      placeholder="policyholder.postCode.placeholder"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="city"
      inputType="text"
      autocompleteType="address-level1"
      label="policyholder.city.label"
      placeholder="policyholder.city.placeholder"
      maxLength="50"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="street"
      inputType="text"
      autocompleteType="address-line1"
      label="policyholder.street.label"
      placeholder="policyholder.street.placeholder"
      maxLength="50"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="houseNumber"
      inputType="text"
      autocompleteType="address-line2"
      label="policyholder.houseNumber.label"
      placeholder="policyholder.houseNumber.placeholder"
      maxLength="10"
    ></app-dynamic-input>
    <app-dynamic-input
      [formGroup]="formGroup"
      name="flatNumber"
      inputType="text"
      autocompleteType="address-line3"
      label="policyholder.flatNumber.label"
      placeholder="policyholder.flatNumber.placeholder"
      maxLength="10"
    ></app-dynamic-input>
  </app-form-element>
  <app-form-element header="policyholder.insuredPersonsData.title" [last]="true">
    <div class="remove-buttons__wrapper" *ngIf="isAppAgentOrTravelAgency && formGroup.controls.insureds.controls.length != 1">
      <button *ngIf="!isActiveRemoveInsureds" nxPlainButton type="button" (click)="handleToggleActiveRemoveInsureds()">
        <nx-icon class="nx-margin-right-2xs" name="trash-o" nxIconPositionStart></nx-icon
        >{{ 'policyholder.insuredPersonsData.buttons.selectPersons' | translate }}
      </button>
      <button
        *ngIf="isActiveRemoveInsureds"
        [disabled]="(disableRemoveButton$ | async) === null || (disableRemoveButton$ | async)"
        nxButton="primary"
        type="button"
        (click)="handleRemoveInsureds()"
      >
        {{ 'policyholder.insuredPersonsData.buttons.remove' | translate }} ({{ (countRemoveInsureds$ | async) || 0 }})
      </button>
      <button
        *ngIf="isActiveRemoveInsureds"
        nxButton="secondary"
        type="button"
        class="cancel-btn"
        (click)="handleToggleActiveRemoveInsureds()"
      >
        {{ 'policyholder.insuredPersonsData.buttons.cancel' | translate }}
      </button>
    </div>
    <nx-checkbox
      *ngIf="formGroup.controls.insureds.controls.length === 1"
      [checked]="insuredPersonCheckbox"
      (checkboxChange)="handleInsuredPerson($event)"
      class="nx-margin-bottom-s"
    >
      {{ 'policyholder.insuredPersonsData.imInsuredPerson' | translate }}
    </nx-checkbox>
    <ng-container>
      <div
        *ngFor="let control of formGroup.controls.insureds.controls; index as i; let length = count"
        class="insured-wrapper"
        [class.padding-top]="length > 1"
      >
        <div class="left-side">
          <app-dynamic-input
            *ngIf="isAppAgentOrTravelAgency && isActiveRemoveInsureds"
            [formGroup]="control"
            name="toRemove"
            inputType="checkbox"
          ></app-dynamic-input>
        </div>
        <div class="right-side">
          <h3 *ngIf="length != 1" nxHeadline="subsection-small" class="nx-font-weight-semibold insured-headline">
            {{ i + 1 }}{{ 'policyholder.insuredPersonsData.insured' | translate }}
            <span *ngIf="(($insuredBirthYears | async) || [])[i]">
              – {{ (($insuredBirthYears | async) || [])[i] }}
              {{ 'policyholder.insuredPersonsData.year' | translate }}
            </span>
          </h3>
          <ul nxList="small" class="addOns-list">
            <li *ngFor="let addOn of getInsuredsAddOnNames(i)" nxListIcon="check" class="addOns-list-item">
              {{ addOn }}
            </li>
            <li *ngFor="let sportName of formsService.getInsuredsSportNames(i)" nxListIcon="check" class="addOns-list-item">
              {{ sportName | translate }}
            </li>
          </ul>
          <ng-template [ngIf]="showUnderLegalAgeMessage(i, formGroup.controls.insureds.value[i].dateOfBirth)">
            <nx-message context="warning" class="addOns-message">
              {{ 'policyholder.insuredPersonsData.underLegalAge' | translate }}
              <span class="addOns-message-bold">{{ 'policyholder.insuredPersonsData.underLegalAgeBold' | translate }}</span>
            </nx-message>
          </ng-template>
          <div class="insured-inputs">
            <app-dynamic-input
              [formGroup]="control"
              name="firstName"
              inputType="text"
              label="policyholder.firstName.label"
              placeholder="policyholder.firstName.placeholder"
              maxLength="30"
            ></app-dynamic-input>
            <app-dynamic-input
              [formGroup]="control"
              name="lastName"
              inputType="text"
              label="policyholder.lastName.label"
              placeholder="policyholder.lastName.placeholder"
              maxLength="50"
            ></app-dynamic-input>
            <app-dynamic-input
              [formGroup]="control"
              name="dateOfBirth"
              inputType="date"
              label="policyholder.dateOfBirth.label"
              [minDate]="(getMinDate$(i) | async) || undefined"
              [maxDate]="(getMaxDate$(i) | async) || undefined"
              [startViewDate]="(getStartViewDate$(i) | async) || 'month'"
              [startAtDate]="getStartAtDate$(i) | async"
            ></app-dynamic-input>
          </div>
        </div>
      </div>
      <nx-message
        *ngIf="formGroup.controls.insureds.controls.length === 1 && (birthDateErrorVisible$ | async)"
        context="error"
        class="nx-margin-top-xs nx-margin-bottom-m"
      >
        {{ 'policyholder.birthDateErrorMessage.content.part1' | translate }} {{ birthDateErrorYear$ | async }}
        {{ 'policyholder.birthDateErrorMessage.content.part2' | translate }}
        <nx-link class="nx-margin-top-2xs" nxStyle="block">
          <a [routerLink]="step2path">
            <nx-icon name="arrow-right"></nx-icon>
            {{ 'policyholder.birthDateErrorMessage.link' | translate }}
          </a>
        </nx-link>
      </nx-message>
    </ng-container>
    <div
      class="remove-buttons__wrapper padding-top"
      *ngIf="isAppAgentOrTravelAgency && isActiveRemoveInsureds && formGroup.controls.insureds.controls.length != 1"
    >
      <button
        [disabled]="(disableRemoveButton$ | async) === null || (disableRemoveButton$ | async)"
        nxButton="primary"
        type="button"
        (click)="handleRemoveInsureds()"
      >
        {{ 'policyholder.insuredPersonsData.buttons.remove' | translate }} ({{ (countRemoveInsureds$ | async) || 0 }})
      </button>
      <button nxButton="secondary" type="button" class="cancel-btn" (click)="handleToggleActiveRemoveInsureds()">
        {{ 'policyholder.insuredPersonsData.buttons.cancel' | translate }}
      </button>
    </div>
  </app-form-element>
</qbe-panel-component>
<qbe-panel-component *ngIf="isAppAgent && (!isBackOfficeAgent || isPostingOnAgentBehalf)" class="nx-margin-top-2m">
  <app-form-element header="policyholder.splitAgent.title">
    <ng-container description>
      <p nxCopytext="normal">
        {{ 'policyholder.splitAgent.description' | translate }}
      </p>
    </ng-container>

    <div class="agent-split-wrapper" *ngFor="let control of agentCommissionSplits.controls.splits.controls; index as i">
      <div class="agent-split-controls">
        <app-dynamic-input
          [formGroup]="control"
          name="agentNumber"
          inputType="number"
          [label]="i === 0 ? 'policyholder.splitAgent.agentNumber' : 'policyholder.splitAgent.intermediaryNumber'"
          [placeholder]="i === 0 ? 'policyholder.splitAgent.agentNumber' : 'policyholder.splitAgent.intermediaryNumber'"
          maxLength="6"
          class="agent-split-controls__control"
        ></app-dynamic-input>
        <app-dynamic-input
          [formGroup]="control"
          name="commissionPercent"
          inputType="number"
          [min]="1"
          [max]="agentCommissionSplits.controls.splits.length > 2 ? getMaxCommissionForThreeAgents(i) : twoAgentsMaxCommision"
          [label]="i === 0 ? 'policyholder.splitAgent.yourCommission' : 'policyholder.splitAgent.commision'"
          [placeholder]="i === 0 ? 'policyholder.splitAgent.yourCommission' : 'policyholder.splitAgent.commision'"
          suffix="policyholder.splitAgent.suffix"
          maxLength="2"
          class="agent-split-controls__control"
        ></app-dynamic-input>
      </div>
      <p class="agent-data-text" nxCopytext="normal">
        {{ control.value.agentData }}
      </p>
      <button *ngIf="i > 0" nxPlainButton type="button" class="agent-split__remove-button" (click)="formsService.removeMiddleman(i)">
        <nx-icon name="trash"></nx-icon>
        {{ 'policyholder.splitAgent.remove' | translate }}
      </button>
    </div>

    <button
      *ngIf="agentCommissionSplits.controls.splits.length < 3"
      nxPlainButton
      type="button"
      class="agent-split__add-button"
      (click)="formsService.addNewMiddleman()"
    >
      <nx-icon name="plus"></nx-icon>
      {{ 'policyholder.splitAgent.add' | translate }}
    </button>
  </app-form-element>
</qbe-panel-component>

<nx-message
  *ngIf="(showPremiumCalculationMessage$ | async) && (premiumCalculationState$ | async) === apiStates.success"
  context="info"
  class="premium-calculation-message"
  (close)="closeNotification()"
  closable
>
  <span class="nx-font-weight-bold"> {{ 'policyholder.insuredPersonsData.messages.success.title' | translate }} </span><br />
  {{ 'policyholder.insuredPersonsData.messages.success.description' | translate }}
</nx-message>
<nx-message
  *ngIf="(showPremiumCalculationMessage$ | async) && (premiumCalculationState$ | async) === apiStates.error"
  context="error"
  class="premium-calculation-message"
  (close)="closeNotification()"
  closable
>
  <span class="nx-font-weight-bold"> {{ 'policyholder.insuredPersonsData.messages.error.title' | translate }} </span><br />
  {{ 'policyholder.insuredPersonsData.messages.error.description' | translate }}
</nx-message>


<ng-container *ngIf="blockInfo$ | async as blockInfo">
  <nx-message *ngIf="blockInfo.isBlocked" context="error" class="premium-calculation-message">
    <span class="nx-font-weight-bold">{{ blockInfo.noticeAboutBlock }}</span> 
  </nx-message>
</ng-container>
